import * as Yup from 'yup'

export const AddEditDeclineReasonFormSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  message: Yup.string().required('Message is required'),
})
